import {RejectBag, RejectBagCallback, RejectBagContractModel} from "@next/eventservice"
import {ShoppingBagApiPost} from "../../api/shoppingbag"

const getBagESB = new RejectBag()
const getBagCallbackESB = new RejectBagCallback()

export const SubscribeToShoppingBagReject = (siteUrl: string) => {
    getBagESB.subscribe(data => {
        LoadApiData(siteUrl, data)
    })
}

class BagRejectApiModel {
    id = ""
}

const LoadApiData = (url: string, data: RejectBagContractModel) => {
    const apiModel = new BagRejectApiModel()
    apiModel.id = data.id

    ShoppingBagApiPost(apiModel, `${url}/bag/reject`, getBagCallbackESB, data.eventId)
}
